(function () {

    'use strict';

    angular.module('Services').factory('ReportingDifotTableService', ReportingDifotTableService);

    ReportingDifotTableService.$inject = [
        'Shipments',
        'TableLiteFactory',
        'CommonService',
        'trackingStatusesConst',
        '$filter',
        'toastr',
        'Carrier',
        '$q',
        'TableHelpers'
    ];

    function ReportingDifotTableService(
        Shipments,
        TableLiteFactory,
        CommonService,
        trackingStatusesConst,
        $filter,
        toastr,
        Carrier,
        $q,
        TableHelpers
    ) {
        return function (serviceDetailsList, chartFilter) {
            let initFilter = angular.copy(chartFilter);
            delete initFilter.carrierProfile;

            let allServices = angular.copy(serviceDetailsList.services);
            let reportingDifotTable = {
                tableName: 'ReportingDifotTableService',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Created Date',
                    viewName: 'createdDate',
                    filterName: 'createdDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        useArray: true,
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        toModel: '',
                        fromModel: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Consignment' + "\u00A0" + 'No.',
                    viewName: 'consignmentId',
                    filterName: 'consignmentId',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Customer Ref' + "\u00A0" + 'No.',
                    viewName: 'customerReferences',
                    filterName: 'customerReferences',
                    type: "array",
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Tracking' + "\u00A0" + 'No.',
                    viewName: 'trackingNumber',
                    filterName: 'trackingNumber',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        model: chartFilter ? chartFilter.carrierProfile : '',
                        filterBy: 'id',
                        items: [],

                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.getExternalCarrierProfiles((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                defer.resolve();
                            }, (error) => {
                                console.log(error);
                                defer.reject();
                            }, { size: 20, name: model });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'SERVICE PROFILE',
                    viewName: 'serviceProfileName',//to fix
                    filterName: 'serviceProfileId',//to fix
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'displayName',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.getServiceProfiles((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                defer.resolve();
                            }, (error) => {
                                console.log(error);
                                defer.reject();
                            }, {
                                size: 20,
                                name: model,
                                carrierProfileId: tableActions.activeFilters.carrierProfileId
                            });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'First Mile',
                    viewName: 'firstMile',
                    filterName: 'breakBulkDetails.firstMile.consignmentId',
                    width: '200px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'Last Mile',
                    viewName: 'lastMile',
                    filterName: 'breakBulkDetails.lastMile.consignmentId',
                    width: '200px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'Amount (Ex' + "\u00A0" + 'Tax)',
                    viewName: 'total',
                    filter: {
                        type: 'number',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                    }
                }, {
                    label: 'Tracking Status',
                    viewName: 'trackingStatus',
                    filterName: 'trackingStatus',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: [{
                            name: 'Documentation Prepared',
                            value: 'documentationprepared'
                        }, {
                            name: 'Booking Arranged',
                            value: 'bookingarranged'
                        }, {
                            name: 'Collected',
                            value: 'collected'
                        }, {
                            name: 'In Transit',
                            value: 'intransit'
                        }, {
                            name: 'Arrived at Destination',
                            value: 'arrivedatdestination'
                        }, {
                            name: 'Out for Delivery',
                            value: 'outfordelivery'
                        }, {
                            name: 'In Store',
                            value: 'instore'
                        }, {
                            name: 'Delivered',
                            value: 'delivered'
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            sendRequest(filter);
                        },
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: resetFilters
            };
            const tableActions = new TableLiteFactory(reportingDifotTable,
                {
                    serviceCallback: Shipments.getDifotSummary,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data, tableActions.activeFilters);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null, tableActions.activeFilters);
                        toastr.error(err);
                    },
                    defaultFilters: angular.extend({
                        removeDelivered: true,
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }, initFilter)
                }
            );
            let sort = tableActions.sort;
            let evaluateFilter = tableActions.evaluateFilter;
            let sendRequest = tableActions.sendRequest;
            let activeFilters = tableActions.activeFilters;

            function resetFilters() {
                angular.forEach(reportingDifotTable.headers, function (header) {
                    if (header.filter) {
                        if (header.filter.model) {
                            header.filter.model = '';
                        }
                        if (header.filter.toModel) {
                            header.filter.toModel = '';
                            delete activeFilters.endDate;
                        }
                        if (header.filter.fromModel) {
                            header.filter.fromModel = '';
                            delete activeFilters.startDate;
                        }
                        delete activeFilters[header.filterName];
                    }
                });
                serviceDetailsList.services.length = 0;
                angular.forEach(allServices, function (service) {
                    serviceDetailsList.services.push(service);
                });
                sendRequest({});
            }

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if (!data)
                    return;
                angular.forEach(data.content, function (val) {
                    val.createdDate = $filter('bbaDate')(val.createdDate);
                    val.consignmentId = val.consignmentId ? val.consignmentId : 'N/A';
                    val.customerReferences = val.customerReferences && val.customerReferences[0] || 'N/A';
                    val.trackingNumber = val.trackingNumber || 'N/A';
                    val.titleLogo = {
                        type: 'logotype',
                        imgSrc: CommonService.isContainLogo(val)
                    };
                    val.carrierProfileName = angular.getObjVal(val, 'serviceProfile.carrierProfile.name') || 'N/A';
                    val.serviceProfileName = angular.getObjVal(val, 'serviceProfile.name') || 'N/A';
                    val.serviceName = angular.getObjVal(val, 'serviceDetails.serviceName') || 'N/A';
                    val.total = Shipments.getShipmentCostFormatted(val).amountFormatted;
                    val.trackingStatus = trackingStatusesConst.trackingStatuses[val.trackingStatus] || 'N/A';
                    val.href = '/shipments/view/' + val.id;

                    val.firstMile = {
                        type: 'multiLine',
                        list: TableHelpers.buildBreakBulkDetails(angular.getObjVal(val, 'breakBulkDetails.firstMile')),
                    }
                    val.lastMile = {
                        type: 'multiLine',
                        list: TableHelpers.buildBreakBulkDetails(angular.getObjVal(val, 'breakBulkDetails.lastMile')),
                    };

                    reportingDifotTable.data.push(val);
                });
            }
            this.tableData = reportingDifotTable;
        };
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/ReportingDifotTableService.js